import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#262261",
    },
    secondary: {
      main: "#116366",
      light: "#dbe5e8"
    },
  },
});